<template>
  <div class="notification-feed box flex">
    <div class="box card-content_icon">
      <div class="box flex row">
        <i class="material-icons">notification_important</i>
      </div>
    </div>
    <div class="box grow card-content_details">
      <div class="box flex row notification-action" v-if="showAction">
        <div class="box first">{{notification.dwellTime}} ago</div>
        <div class="box grow flex gaps last reverse">
          <el-tooltip
            class="item"
            effect="dark"
            :content="'Mark as read'"
            placement="top"
            :enterable="false"
          >
            <span
              class="notification-action_mark_read cursor-pointer"
              @click="markNotificationRead(notification)"
            >
              <i class="circle" :class="{'read': notification.read}"></i>
            </span>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="'Clear notification'"
            placement="top"
            :enterable="false"
          >
            <span
              class="notification-action_mark_cleared cursor-pointer"
              @click="markNotificationCleared(notification)"
            >
              <i class="material-icons">delete</i>
            </span>
          </el-tooltip>
        </div>
      </div>
      <notification-trail-event
        v-if="notification.details.eventType === notificationType.TRAIL"
        :notification-details="notification.details"
        @notification-toggle="toggleNotification"
      />
      <notification-host-event
        v-else-if="notification.details.eventType === notificationType.HOST"
        :notification-details="notification.details"
        @notification-toggle="toggleNotification"
      />
      <notification-assignment-event
        v-else
        :notification-details="notification.details"
        @notification-toggle="toggleNotification"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  NOTIFICATION_READ_REQUEST,
  NOTIFICATION_READ_SUCCESS,
  NOTIFICATION_READ_ERROR,
  NOTIFICATION_CLEAR_REQUEST,
  NOTIFICATION_CLEAR_SUCCESS,
  NOTIFICATION_CLEAR_ERROR
} from "@/store/modules/notifications/notifications.type";
import RiskLevelButton from "@/components/button/RiskLevelButton.vue";
import {
  NotificationTrailEvent,
  NotificationHostEvent,
  NotificationAssignmentEvent
} from "@/components/card/notification";

import {
  NotificationTypeEnum,
  NotificationCategoryEnum
} from "@/constants/notification.constants";

export default {
  name: "NotificationCard",
  props: {
    notification: { type: Object },
    showAction: { type: Boolean, default: true }
  },
  data() {
    return {
      notificationType: NotificationTypeEnum
    };
  },
  mounted() {},
  methods: {
    markNotificationRead(notification) {
      this.$store
        .dispatch(NOTIFICATION_READ_REQUEST, notification)
        .then(resp => {
          this.$emit("notification-read");
        });
    },
    markNotificationCleared(notification) {
      this.$store
        .dispatch(NOTIFICATION_CLEAR_REQUEST, notification)
        .then(resp => {
          this.$emit("notification-clear");
        });
    },
    toggleNotification() {
      this.$store
        .dispatch(NOTIFICATION_READ_REQUEST, this.notification)
        .then(resp => {
          this.$emit("notification-read");
          this.$emit('notification-toggle');
        });
    }
  },
  components: {
    RiskLevelButton,
    NotificationTrailEvent,
    NotificationHostEvent,
    NotificationAssignmentEvent
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";
@import "assets/styles/riskscore_colors.css";

.notification-feed {
  background-color: var(--gray-50);
  margin: 10px 20px;
}

.card-content_icon {
  margin: auto 10px;

  > .box {
    line-height: 100px;
    vertical-align: middle;
  }

  .material-icons {
    border: 1px solid var(--aluminum-600);
    border-radius: 50%;
    color: white;
    background: var(--aluminum-600);
    padding: 2px;
  }
}

.card-content_details {
  margin: 10px 12px;

  > .box {
    margin: 10px 0px;
  }

  > .box:last-of-type {
    .box {
      margin-right: auto;
    }

    .notification-action_before,
    .notification-action_after {
      border: 1px solid var(--border-color);
      padding: 3px 10px;
      position: relative;
    }

    .notification-action_before::before {
      content: "";
      display: block;
      background-color: black;
      height: 1px;
      position: absolute;
      max-width: 100px;
      width: 100px;
      top: 50%;
      left: -2px;
    }
  }
}

.notification-action {
  .material-icons {
    font-size: 18px;
    color: var(--aluminum-600);
  }
}

.notification-action_mark_read {
  margin: 2px 0px;

  .circle {
    width: 14px;
    height: 14px;
    display: table-cell;
    border-radius: 50%;
    background: var(--primary-blue-400);
  }

  .read {
    background: var(--gray-200);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/card/notification/NotificationCard.vue